import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { LoginPage } from "@/routes/Login";
import { DashboardPage } from "@/routes/Dashboard";
import { InstanceDetailPage } from "@/routes/InstanceDetail";
import { InstanceUsagePage } from "@/routes/InstanceUsage";
import { InstanceEmployeeFormPage } from "@/routes/InstanceEmployeeForm";
import { AiAssistantSettingsPage } from "@/routes/AiAssistantSettings";
import { PromptsListPage } from "@/routes/PromptsList";
import { AiAssistantPromptPage } from "@/routes/AiAssistantPrompt";
import { EmployeeTemplatePromptPage } from "@/routes/EmployeeTemplatePrompt";
import { LlmToolsListPage } from "@/routes/LlmToolsList";
import { LlmToolFormPage } from "@/routes/LlmToolForm";
import { BillingSettingsPage } from "@/routes/BillingSettings";
import { MarginDashboardPage } from "@/routes/MarginDashboard";
import { BillingPaymentsPage } from "@/routes/BillingPayments";
import { RequireAuth } from "@/routes/RequireAuth";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="instances/:name" element={<InstanceDetailPage />} />
          <Route path="instances/:name/usage" element={<InstanceUsagePage />} />
          <Route path="instances/:name/employees/new" element={<InstanceEmployeeFormPage />} />
          <Route path="instances/:name/employees/:employeeId" element={<InstanceEmployeeFormPage />} />

          {/* LLM Templates — AI Assistant + Employee templates in one place. */}
          <Route path="templates" element={<PromptsListPage />} />
          <Route path="templates/ai-assistant" element={<AiAssistantPromptPage />} />
          <Route path="templates/ai-assistant/settings" element={<AiAssistantSettingsPage />} />
          <Route path="templates/employee/:id" element={<EmployeeTemplatePromptPage />} />

          {/* LLM Tools — central catalog. */}
          <Route path="tools" element={<LlmToolsListPage />} />
          <Route path="tools/new" element={<LlmToolFormPage />} />
          <Route path="tools/:id" element={<LlmToolFormPage />} />

          {/* Billing catalog — rate card, model prices, credit packs. */}
          <Route path="billing" element={<BillingSettingsPage />} />

          {/* Margin monitoring — usage rollups + margin dashboard. */}
          <Route path="billing/margin" element={<MarginDashboardPage />} />

          {/* Payments registry — invoices, subscriptions, CSV export. */}
          <Route path="billing/payments" element={<BillingPaymentsPage />} />

          {/* Legacy URLs from inline-HTML era — keep redirecting so old bookmarks survive. */}
          <Route path="prompts" element={<Navigate to="/templates" replace />} />
          <Route path="prompts/ai-assistant" element={<Navigate to="/templates/ai-assistant" replace />} />
          <Route path="prompts/employee/:id" element={<EmployeeTemplatePromptRedirect />} />
          <Route path="settings/ai-assistant" element={<Navigate to="/templates/ai-assistant/settings" replace />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function EmployeeTemplatePromptRedirect() {
  // Preserve the :id when redirecting from the legacy path.
  const path = window.location.pathname.replace(/^\/prompts\/employee\//, "/templates/employee/");
  return <Navigate to={path} replace />;
}
